export class ClinicLocationModel {
    location_id: number
    location_code: string
    location_desc: string
    remarks: string
    clinic_no: number

    constructor(
        location_id: number,
        location_code: string,
        location_desc: string,
        remarks: string,
        clinic_no: number
    ) {
        this.location_id = location_id
        this.location_code = location_code
        this.location_desc = location_desc
        this.remarks = remarks
        this.clinic_no = clinic_no
    }
}
